<section class="breadcrumbs_common bg_img pos_relative">
    <div class="overlay-innerpage"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumbs_content">
                    <h1 class="text-white">Master of Science in Computer Science (M.Sc. CS)</h1>
                    <ul class="breadcrumb">
                        <li>
                            <a routerLink="/">Programs</a>
                        </li>
                        /
                        <li class="active">
                            <a href="javascript:void(0);">Master of Science in Computer Science (M.Sc. CS)</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="text-center">
            <img src="assets/images/comming-soon.avif" alt="MSC PROGRAM | GHRCACS, PUNE" class="img-fluid">
        </div>
    </div>
</section>
